import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import axios from 'axios';
import { Baseurl } from '../../config/BaseUrl';
const initialState = {
  isAuth: false,
  name: '',
  loginData: '',
  email: '',
  totalCars: [],
  availibilityStatus: false,
  brandLogo: '',
};

export const employeeLoginBypassword = createAsyncThunk(
  'employee/employeeLoginBypassword',
  async (formData, thunkAPI) => {
    try {
      const config = {
        Headers: {'Content-Type': 'application/json'},
      };
      const url = `${Baseurl}/api/v1/employees/loginwithpassword`;
      console.log(url,"url");
      console.log(formData,"formData");

      const resp = await axios.post(url, formData, config);
      console.log(resp.data,"resp.data");
      return resp.data;
    } catch (error) {
      return error.response.data;
    }
  },
);



export const employeeLogin = createAsyncThunk(
  'Athentication/employeeLogin',
  async (formData, thunkAPI) => {
    try {
      const config = {
        Headers: {'Content-Type': 'application/json'},
      };
      const url = `${Baseurl}/api/v1/employees/verifyphone`;
      const resp = await axios.post(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue('Pls check your information');
    }
  },
);
const ClientAuthenticationSlice = createSlice({
  name: 'Authentication',
  initialState,
  reducers: {
    signIn(state, action) {
      state.isAuth = action.payload.isAuth;
        state.clientId = action.payload._id;
        state.email = action.payload.email;
        state.name = action.payload.name;
        state.role = action.payload.role;
        state.loginData = action.payload;
        state.availibilityStatus=action.payload.availabilityStatus
    },
    signOut(state) {
      // AsyncStorage.removeItem('loginData');
      state.isAuth = false;
      state.clientId = '';
        state.email = '';
        state.name = '';
        state.role = '';
        state.loginData = '';
        state.availibilityStatus= false;
        state.totalCars=[];
        state.notifications=[];
    },
    getCars(state, action) {
      state.totalCars = action.payload;
    },
    setAvailibility(state, action) {
      state.availibilityStatus = action.payload;
    },
    getNotification(state, action) {
      state.notifications=action.payload.filter((individualNotification)=>
      individualNotification.agent.id===state.loginData._id
      )
    },
    updateNotification(state, action) {
      state.notifications = state.notifications.filter(
        individualNotification =>
          individualNotification._id !== action.payload._id,
      );
    },
    getlogo(state, action) {
      state.brandLogo = action.payload;
    },
  },
});

export const clientActions = ClientAuthenticationSlice.actions;
export default ClientAuthenticationSlice.reducer;
